import React, { useEffect, useState } from "react";
import { useDoubtActions, useDoubtReportReasons } from "../../../hooks/useDoubts";
import "./FilterBlog.css";
import "./DoubtReport.css";

const firstArray = (...values) => values.find(Array.isArray) || [];

const CloseIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M3.33337 3.33334L12.6667 12.6667"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M12.6667 3.33334L3.33337 12.6667"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const ReportModal = ({ open, onClose, onOpen, doubtId, language = "EN" }) => {
  const [selectedReasonId, setSelectedReasonId] = useState("");
  
  const reasonsQuery = useDoubtReportReasons(language, open && Boolean(doubtId));
  const reasonRows = firstArray(
    reasonsQuery.data?.report_reasons,
    reasonsQuery.data?.reasons,
    reasonsQuery.data?.data,
    reasonsQuery.data,
  );
  const actions = useDoubtActions(doubtId, language);

  useEffect(() => {
    if (open) {
      onOpen?.();
      setSelectedReasonId(""); // reset on open
    }
  }, [open, onOpen]);

  if (!open) return null;

  const handleSubmit = async () => {
    if (doubtId && selectedReasonId) {
      await actions.report.mutateAsync({ reportReasonId: selectedReasonId, description: "" });
      onClose();
    }
  };

  const isPending = actions.report.isPending;

  return (
    <div className="filter-blog-overlay" onClick={onClose}>
      <div
        className="filter-blog-modal doubtReport-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="close-btn2 text-end unlock-close-btn">
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          />
        </div>

        {/* Icon */}
        <div className="premium-icon daily-icon iconnn  ms-auto me-auto d-flex">
          <i className="bi bi-info-circle"></i>
        </div>

        {/* Title */}
        <h5 className="fw-bold blackText mb-2 ms-auto me-auto text-center">Report</h5>

        <div className="filter-blog-modal__body doubtreport-body">
          <div
            className="doubtreport-options"
            role="radiogroup"
            aria-label="Report reason"
          >
            {reasonRows.map((reason, index) => {
              const optionId = `doubt-report-reason-${reason?.report_reason_id || reason?.id || index}`;
              const reasonText = reason?.name || reason?.reason || reason?.title || "Report reason";
              const reasonVal = reason?.report_reason_id || reason?.id || "";

              return (
                <label
                  key={optionId}
                  className="doubtreport-option"
                  htmlFor={optionId}
                >
                  <input
                    id={optionId}
                    type="radio"
                    name="doubt-report-reason"
                    value={reasonVal}
                    checked={String(selectedReasonId) === String(reasonVal)}
                    onChange={() => setSelectedReasonId(reasonVal)}
                  />
                  <span
                    className="doubtreport-option__radio"
                    aria-hidden="true"
                  />
                  <span className="doubtreport-option__text">{reasonText}</span>
                </label>
              );
            })}
          </div>
        </div>

        <div className="filter-blog-modal__footer doubtReport-footer">
          <button
            type="button"
            className="filter-blog-modal__action filter-close"
            onClick={onClose}
          >
            <span>Close</span>
          </button>

          <button
            type="button"
            className="filter-blog-modal__action filter-blog-modal__action--apply"
            onClick={handleSubmit}
            disabled={!selectedReasonId || isPending}
          >
            <span>{isPending ? "Submitting..." : "Submit"}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
